module.exports = __webpack_public_path__ + "img/unanswered-responses.6c9d8b6e.svg";